export default __webpack_public_path__ + "static/media/telegram.259397a7.png";